function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function e(e) {
  const t = "==".slice(0, (4 - e.length % 4) % 4),
        n = e.replace(/-/g, "+").replace(/_/g, "/") + t,
        i = atob(n),
        r = new ArrayBuffer(i.length),
        a = new Uint8Array(r);

  for (let e = 0; e < i.length; e++) a[e] = i.charCodeAt(e);

  return r;
}

function t(e) {
  const t = new Uint8Array(e);
  let n = "";

  for (const e of t) n += String.fromCharCode(e);

  return btoa(n).replace(/\+/g, "-").replace(/\//g, "_").replace(/=/g, "");
}

const n = "copy",
      i = "convert";

function r(e, t, a) {
  if (t === n) return a;
  if (t === i) return e(a);
  if (t instanceof Array) return a.map(n => r(e, t[0], n));

  if (t instanceof Object) {
    const n = {};

    for (const _ref of Object.entries(t)) {
      var _ref2 = _slicedToArray(_ref, 2);

      const i = _ref2[0];
      const s = _ref2[1];
      if (i in a) null != a[i] ? n[i] = r(e, s.schema, a[i]) : n[i] = null;else if (s.required) throw new Error("Missing key: ".concat(i));
    }

    return n;
  }
}

function a(e) {
  return {
    required: !0,
    schema: e
  };
}

function s(e) {
  return {
    required: !1,
    schema: e
  };
}

const o = {
  type: a(n),
  id: a(i),
  transports: s(n)
},
      c = {
  appid: s(n),
  appidExclude: s(n)
},
      l = {
  appid: s(n),
  appidExclude: s(n)
},
      u = {
  publicKey: a({
    rp: a(n),
    user: a({
      id: a(i),
      name: a(n),
      displayName: a(n)
    }),
    challenge: a(i),
    pubKeyCredParams: a(n),
    timeout: s(n),
    excludeCredentials: s([o]),
    authenticatorSelection: s(n),
    attestation: s(n),
    extensions: s(c)
  }),
  signal: s(n)
},
      d = {
  type: a(n),
  id: a(n),
  rawId: a(i),
  response: a({
    clientDataJSON: a(i),
    attestationObject: a(i)
  }),
  clientExtensionResults: a(l)
},
      p = {
  mediation: s(n),
  publicKey: a({
    challenge: a(i),
    timeout: s(n),
    rpId: s(n),
    allowCredentials: s([o]),
    userVerification: s(n),
    extensions: s(c)
  }),
  signal: s(n)
},
      f = {
  type: a(n),
  id: a(n),
  rawId: a(i),
  response: a({
    clientDataJSON: a(i),
    authenticatorData: a(i),
    signature: a(i),
    userHandle: a(i)
  }),
  clientExtensionResults: a(l)
},
      g = {
  credentialCreationOptions: u,
  publicKeyCredentialWithAttestation: d,
  credentialRequestOptions: p,
  publicKeyCredentialWithAssertion: f
};

async function y(n) {
  const i = r(e, u, n),
        a = await navigator.credentials.create(i);
  return a.clientExtensionResults = a.getClientExtensionResults(), r(t, d, a);
}

async function h(n) {
  const i = r(e, p, n),
        a = await navigator.credentials.get(i);
  return a.clientExtensionResults = a.getClientExtensionResults(), r(t, f, a);
}

function w() {
  return !!(navigator.credentials && navigator.credentials.create && navigator.credentials.get && window.PublicKeyCredential);
}

export { y as create, h as get, g as schema, w as supported };